import { render } from "./StaffLogin.vue?vue&type=template&id=3ed4fed9"
import script from "./StaffLogin.vue?vue&type=script&lang=js"
export * from "./StaffLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__